/* eslint jsx-a11y/mouse-events-have-key-events: 0 */
import React, { useState, createRef } from 'react'
import PropTypes from 'prop-types'
import styles from '../App.scss'

const Zoom = (props) => {
    const [ zoom, setZoom ] = useState(false)
    const [ mouseX, setMouseX ] = useState(null)
    const [ mouseY, setMouseY ] = useState(null)

    const {
      height,
      img,
      transitionTime,
      width,
    } = props

    let outerDivStyle = {
      height: `${height}px`,
      width: `${width}px`,
      overflow: 'hidden',
    }

    let innerDivStyle = {
      height: `${height}px`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'auto 100%',
      transition: `transform ${transitionTime}s ease-out`,
      backgroundImage: `url('${img}')`,
    }

    let imageRef = createRef()

  const handleMouseOver = () => {
    setZoom(true)
  }

  const handleMouseOut = () => {
    setZoom(false)
  }

  const handleMouseMovement = (e) => {
    const {
      left: offsetLeft,
      top: offsetTop,
    } = imageRef.current.getBoundingClientRect()

    const {
      current: {
        style: {
          height,
          width,
        },
      },
    } = imageRef

    const x = ((e.pageX - offsetLeft) / parseInt(width, 10)) * 100
    const y = ((e.pageY - offsetTop) / parseInt(height, 10)) * 100

    setMouseX(x)
    setMouseY(y)

  }

    const transform = {
        transformOrigin: `${mouseX}% ${mouseY}%`,
    }

return (
    <div
    style={outerDivStyle}
    onMouseOver={handleMouseOver}
    onMouseOut={handleMouseOut}
    onMouseMove={handleMouseMovement}
    ref={imageRef}
    >
    <div
        style={{
        ...transform,
        ...innerDivStyle,
        transform: zoom ? `scale(${props.zoomScale})` : 'scale(1.0)',
        }}
        className={styles.zoomImg}
    />
    </div>
)
}

Zoom.propTypes = {
  /** The path to the image. It can be a url. */
  img: PropTypes.string.isRequired,
  /** The zoom scale. */
  zoomScale: PropTypes.number.isRequired,
  /** The height of the image in pixels */
  height: PropTypes.number.isRequired,
  /** The width of the image in pixels */
  width: PropTypes.number.isRequired,
  /** The time (in seconds) that will take to scale your image. */
  transitionTime: PropTypes.number,
}

Zoom.defaultProps = {
  transitionTime: 0.1,
}

export default Zoom